import * as React from "react";
const SvgFiRrRadio = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-radio_svg__a)">
      <path
        fill="#062147"
        d="M19 6h-8.953l11.291-4.06A1 1 0 1 0 20.662.06L3.452 6.246A5.01 5.01 0 0 0 0 10.999v8c0 2.758 2.243 5 5 5h14c2.757 0 5-2.242 5-5v-8c0-2.756-2.243-5-5-5m3 13a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3zM9 15a1 1 0 0 1-1 1H5a1 1 0 0 1 0-2h3a1 1 0 0 1 1 1m0 4a1 1 0 0 1-1 1H5a1 1 0 0 1 0-2h3a1 1 0 0 1 1 1m0-8a1 1 0 0 1-1 1H5a1 1 0 0 1 0-2h3a1 1 0 0 1 1 1m6.5-.5A4.505 4.505 0 0 0 11 15c0 2.48 2.019 4.5 4.5 4.5S20 17.48 20 15c0-2.482-2.019-4.5-4.5-4.5m0 7A2.503 2.503 0 0 1 13 15c0-1.379 1.122-2.5 2.5-2.5S18 13.62 18 15c0 1.378-1.122 2.5-2.5 2.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-radio_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRadio;
